import React, { useEffect, useState } from 'react';
import interact from 'interactjs';
import ChatWidget from '../../../components/partials/dashboard/CallIcon/chatWidget';
import CallHistory from './callhistory';
import Form from './form';
import { useFloatingPanel } from './useFloatingPanelState';
import Minimize from '@mui/icons-material/CloseFullscreen';
import Maximize from '@mui/icons-material/OpenInFull';
import { IoCall } from "react-icons/io5";
import { FaHistory, FaWpforms } from "react-icons/fa";

const FloatingPanels = () => {
  const {
    showPhone, showHistory, showForm,
    togglePhone, toggleHistory, toggleForm,
    positions, updatePosition, isMinimized, toggleMinimized
  } = useFloatingPanel();

  useEffect(() => {
    interact('.floating-panel').draggable({
      allowFrom: '.panel-header',
      listeners: {
        move(event) {
          const id = event.target.id;
          const x = (parseFloat(event.target.getAttribute('data-x')) || 0) + event.dx;
          const y = (parseFloat(event.target.getAttribute('data-y')) || 0) + event.dy;

          event.target.style.transform = `translate(${x}px, ${y}px)`;
          event.target.setAttribute('data-x', x);
          event.target.setAttribute('data-y', y);
          updatePosition(id, x, y);
        }
      }
    });
  }, [updatePosition]);

  const [status, setStatus] = useState("DISCONNECTED");
  const [activeModal, setActiveModal] = useState("");
  useEffect(() => {
    const interval = setInterval(() => {
      const savedStatus = sessionStorage.getItem("webrtcPhoneStatus");
      if (savedStatus && savedStatus !== status) {
        setStatus(savedStatus);
      }
    }, 1000); // check every 1 second

    return () => clearInterval(interval); 
  }, [status]);

  useEffect(() => {
    if (activeModal) {
      sessionStorage.setItem("showCallIcon", "false");
    } else {
      sessionStorage.setItem("showCallIcon", "true");
    }
  }, [activeModal]);

  const [showPhoneWebrtc, setShowPhoneWebrtc] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      const savedStatus = sessionStorage.getItem("showWebrtc");
      const shouldShow = savedStatus === "YES";
      if (shouldShow !== showPhoneWebrtc) {
        setShowPhoneWebrtc(shouldShow);
      }
    }, 1000); // check every 1 second

    return () => clearInterval(interval); 
  }, [showPhoneWebrtc]);

  const handleClosePhonePanel = () => {
    togglePhone(); // updates showPhone in your floating panel state
    setShowPhoneWebrtc(false); // also force hide the WebRTC panel
    sessionStorage.setItem("showWebrtc", "NO"); // Persist the close action to prevent immediate reopening
    sessionStorage.setItem("showCallIcon", "true");
    setActiveModal("");
  };

  const buttonStyle = (color, isActive) => ({
    border: "none",
    width: "48px",
    height: "42px",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: isActive ? color : "transparent",
    transition: "transform 0.3s",
    cursor: "pointer",
    marginBottom: "10px",
    // boxShadow: isActive ? "0 0 10px rgba(255, 255, 255, 0.4)" : "none",
    transform: isActive ? "scale(1.05)" : "scale(1)",
  });

  return (
    <>
      <style>
        {`
             #panelPhone .chatbox-wrapper {
             padding: 20px 0 !important;
            //  width: 320px !important;
             }
        `}
      </style>
      {/* {(showPhone || (status === "CONNECTED" && showPhoneWebrtc)) && (
        <div
          className="floating-panel active"
          id="panelPhone"
          data-x={positions.panelPhone.x}
          data-y={positions.panelPhone.y}
          style={{
            transform: `translate(${positions.panelPhone.x}px, ${positions.panelPhone.y}px)`,
            boxShadow: "0 4px 12px rgba(57, 103, 255, 0.2)",
            backgroundColor: "white",
            height: isMinimized ? "100px" : "auto",
            overflowY: isMinimized ? "hidden" : "visible",
          }}
        >
          {activeModal &&
          <div
            className="panel-header"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#081d5d",
              position: "relative",
              padding: "8px 12px",
              color: "white",
              // fontWeight: "bold",
              fontSize: "18px",
              marginBottom: "8px",
              borderTopRightRadius: "0px"
            }}
          >
            <span
              style={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              {activeModal === "WEB" ? "WebRTC Phone" : ""} 
              {activeModal === "CALL_HISTORY" ? "Call History" : ""}
              {activeModal === "DISPOSITION" ? "Disposition" : ""}
            </span>

          
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <span
                className="minimize-btn"
                onClick={toggleMinimized}
                style={{
                  cursor: "pointer",
                  marginRight: "20px",
                  fontWeight: "bold",
                }}
              >
                {isMinimized ? (
                  <Maximize sx={{ fontSize: 22, color: "white" }} />
                ) : (
                  <Minimize sx={{ fontSize: 22, color: "white" }} />
                )}
              </span>
              <span
                className="close-btn"
                onClick={handleClosePhonePanel}
                style={{ cursor: "pointer" }}
              >
                ×
              </span>
            </div>
          </div>}

          <div style={{ position: "fixed", top: "0px", right: "-57px", background: "rgb(8, 29, 93)", padding: "10px 0px", borderRadius: "10px", height: "583px", borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px", paddingTop: "0px", border: "5px solid rgb(8, 29, 93)" }}>
              <button style={buttonStyle('#ffffffff', activeModal === "WEB")} onClick={() => setActiveModal("WEB")}>
                <IoCall style={{ fontSize: "24px" }} color={activeModal === "WEB" ? "rgb(8, 29, 93)" : "white"}/>
              </button>
              <button style={buttonStyle('#ffffffff', activeModal === "CALL_HISTORY")} onClick={() => setActiveModal("CALL_HISTORY")}>
                <FaHistory style={{ fontSize: "24px" }} color={activeModal === "CALL_HISTORY" ? "rgb(8, 29, 93)" : "white"}/>
              </button>
              <button style={buttonStyle('#ffffffff', activeModal === "DISPOSITION")} onClick={() => setActiveModal("DISPOSITION")}>
                <FaWpforms style={{ fontSize: "24px" }} color={activeModal === "DISPOSITION" ? "rgb(8, 29, 93)" : "white"}/>
              </button>
            </div>

          {activeModal === "WEB" ? <div>
              <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                fontSize: "15px",
                marginBottom: "4px",
                background:
                  status === "DISCONNECTED"
                    ? "rgba(255, 69, 58, 0.1)"
                    : "rgba(52, 199, 89, 0.1)",
                padding: "6px 12px",
                borderRadius: "20px",
                border:
                  status === "DISCONNECTED"
                    ? "1px solid rgba(255, 69, 58, 0.3)"
                    : "1px solid rgba(52, 199, 89, 0.3)",
              }}
            >
              <span
                style={{
                  color: status === "DISCONNECTED" ? "#ff3b30" : "#34c759",
                  marginRight: "6px",
                }}
              >
                ●
              </span>
              <span>Call Status:</span>
              <span
                id="callStatusText"
                style={{
                  fontWeight: "bold",
                  fontSize: "18px",
                  marginLeft: "6px",
                  color: status === "DISCONNECTED" ? "#ff3b30" : "#34c759",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {status}
              </span>
            </span>
          </div>

        
          <div
            style={{
              display: isMinimized ? "none" : "block",
              marginTop: "4px",
            }}
          >
            <div
              className="panel-body p-0"
              style={{
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                overflowX: "scroll",
                height: "484px",
                borderBottomRightRadius: "0px"
              }}
            >
              <ChatWidget />
            </div>
          </div></div> : activeModal === "CALL_HISTORY" ? (
            <div className="panel-body" style={{ height: "532px", borderBottomRightRadius: "0px" }}><CallHistory /></div>
              ) : activeModal === "DISPOSITION" ? (
              <div className="panel-body" style={{ height: "532px", overflowY: "scroll", borderBottomRightRadius: "0px" }}><Form /></div>
          ) : null}
        </div>
      )} */}
      {showHistory && (
        <div
          id="panelHistory"
          className="floating-panel active wide-panel"
          data-x={positions.panelHistory.x}
          data-y={positions.panelHistory.y}
          style={{
            width: "480px",
            transform: `translate(${positions.panelHistory.x}px, ${positions.panelHistory.y}px)`,
          }}
        >
          <div className="panel-header bg-success">
            Call History{" "}
            <span className="close-btn" onClick={toggleHistory}>
              ×
            </span>
          </div>
          <div className="panel-body">
            <CallHistory />
          </div>
        </div>
      )}
      {showForm && (
        <div
          id="panelForm"
          className="floating-panel active"
          data-x={positions.panelForm.x}
          data-y={positions.panelForm.y}
          style={{
            transform: `translate(${positions.panelForm.x}px, ${positions.panelForm.y}px)`,
          }}
        >
          <div
            className="panel-header"
            style={{ backgroundColor: "#081d5d", color: "white" }}
          >
            Disposition{" "}
            <span className="close-btn" onClick={toggleForm}>
              ×
            </span>
          </div>
          <div className="panel-body">
            <Form />
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingPanels;